import { useFormField, useFormContext } from '@calendly/form'
import { Avatar } from '@calendly/ui/components/avatar'
import { BodyText } from '@calendly/ui/components/typography'

import { useGetUserQuery } from 'common'
import { getMemberName } from 'components/event_type_edit'
import { Layout } from 'components/layout'

import { FullStoryExclude, FullStoryMask } from '../../../../../../../../../shared/fullstory_privacy'

export const MemberContent = ({ formPath }) => {
  const { data: currentUser } = useGetUserQuery()
  const [{ value: availabilityMembership }] = useFormField({ name: formPath })
  const { values: { memberships = [] } } = useFormContext()
  const isPending = availabilityMembership.isPending || availabilityMembership.is_pending

  const membership = memberships.find((m) => (isPending
    ? m.organization_invitation_id === availabilityMembership.organizationInvitationId
    : m.user_id === availabilityMembership.userId
  ))

  if (!membership) { return null }

  const memberName = getMemberName({ name: availabilityMembership.name, user_uuid: availabilityMembership.userUuid }, currentUser)

  return (
    <Layout align="center" gap="12">
      <FullStoryExclude>
        <Avatar size="x-small" src={membership.avatar_url} letter={membership.avatar_letter} alt={membership.name} />
      </FullStoryExclude>
      <BodyText size="large" weight="bold">
        <FullStoryMask>
          {memberName}
        </FullStoryMask>
      </BodyText>
    </Layout>
  )
}
